// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMPLAINT_USERS_PROFILE_AVATAR_NOT_ALONE = "Na profilovej fotke m\u00e1 by\u0165 iba tvoja tv\u00e1r";
export const COMPLAINT_USERS_PROFILE_AVATAR_NOT_VISIBLE_FACE = "Na fotoportr\u00e9te m\u00e1 by\u0165 jasne vidie\u0165 tvoju tv\u00e1r";
export const COMPLAINT_USERS_PROFILE_AVATAR_NOT_YOU = "Na fotoportr\u00e9te m\u00e1 by\u0165 tvoja skuto\u010dn\u00e1 tv\u00e1r";
export const SINCE = "od";
export const THE_AVATAR_HAS_BEEN_BLOCKED_BY_ADMINS_IT_BREACHES_THE_RULES = "Profilov\u00fa fotku vid\u00ed\u0161 iba ty. ";
